import { ReactElement } from 'react'
import { RootState } from '@types'
import { createSelector } from 'reselect'

export const selectDialogComponent = createSelector(
  (state: RootState): (() => ReactElement) => state.Dialog.component,
  (component) => component,
)
